<template>
  <div class="main_box">
    <div class="main_bar">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">
            {{ formTitle }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_body">
      <el-steps class="vote_step" :active="2" align-center>
        <el-step
          title="基本信息"
          icon="iconfont icon-jibenxinxi"
          description="投票标题、类型、规则"
          status="success"
          @click.native="stepClick(1)"
        ></el-step>
        <el-step
          title="投票人员"
          icon="iconfont icon-pingweiguanli"
          description="管理投票人员"
          status="wait"
          @click.native="stepClick(2)"
        ></el-step>
        <el-step
          title="待评项目"
          icon="iconfont icon-zu"
          description="管理待评项目"
          status="process"
          @click.native="stepClick(3)"
        ></el-step>
      </el-steps>
      <div class="main_form">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// import voteManageApi from '../../../api/vote/voteManage' // voteManage投票管理接口
export default {
  data () {
    return {
      formTitle: '新增投票'
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    stepClick: function (step) {
      switch (step) {
        case 1:
          this.$router.push({ name: 'editVoteBasic', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
          break
        case 2:
          this.$router.push({ name: 'editVoteUser', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
          break
        case 3:
          this.$router.push({ name: 'editVoteProject', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
          break
      }
    }
  },
  created () {
    if (this.$route.params.vid === '0') {
      this.formTitle = '新增投票'
    } else {
      this.formTitle = '编辑投票'
    }
    this.stepClick(1)
  }
}
</script>
<style lang="less">
.el-step__icon {
  background-color: #fff;
}
.el-step:hover {
  background-color: #f5f7fa;
  cursor: pointer;
}
.el-step:hover .el-step__head .el-step__icon {
  background-color: #f5f7fa;
}
.el-step:hover .el-step__head .el-step__line {
  left: 100%;
}
.el-step:hover .el-step__head .el-step__line .el-step__line-inner {
  width: 100% !important;
}
</style>
